<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-xm(:title="$t('mantra')")
    .grid.is-widescreen-8.is-desktop-10
      .column
        p.u-text-lg {{$t('mantraDesc')}}


  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec1')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec3')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-xs(v-for="item,idx in $t('sec3Items')")
            p {{item}}

  section.u-mt-md.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Big data and analytics",
    "pageDesc":"Gain insights thorough insight and boost your business by analyzing the data you have and forecasting the future changes.",
    "mantra":"Empower your business with |big data and analytics.",
    "mantraDesc":"We will Help you to be a data driven business and use data as analytical tool through Analyze your collected data, discover meaningful insights, and give you advice to optimize your business and guide your decision-making process.",
    "sec1":"Turning numbers into valuable data.",
    "sec1Items":{
      "1":{
        "title":"Customer data analysis",
        "desc":"The more you know about your customer behaviors, the more you can increase their loyalty. We will help you discover useful insights using historical data."
      },
      "2":{
        "title":"Sales data analysis",
        "desc":"We will help you generate insights from sales data to set targets and forecast future sales and demands."
      },
      "3":{
        "title":"HR data analysis",
        "desc":"Use both people-data collected by HR systems and business information such as operations performance in order to improve your employees’ performance."
      },
      "4":{
        "title":"Other analysis services",
        "desc":"And more and more of analysis that would optimize your business such as Social Media Data analysis, Performance data analysis, Ecommerce data analysis."
      }
    },
    "sec2":"We customize our services to your needs.",
    "sec2Items":{
      "1":{
        "title":"Consulting.",
        "desc":"Our consultants will give you advice and help you answer your business questions."
      },
      "2":{
        "title":"Implementation of a data analysis solution.",
        "desc":"We will analyze your specific business requirements and suggest an optimal solution for you."
      },
      "3":{
        "title":"Outsourced data analysis",
        "desc":"We can help you getting insightful analytical reports and dashboards or static without worrying about how to do it. We just need your permission to access your data and we can ensure you high-quality results, safety and privacy."
      }
    },
    "sec3":"Capitalizing on the power of cutting edge technologies.",
    "sec3Items":{
      "1":"Business Intelligence Technologies:",
      "2":"Power BI",
      "3":"Tableau",
      "4":"QlikView",
      "5":"Looker",
      "6":"Microsoft SQL Data Tools (SSDT)",
      "7":"Google Analytics",
      "8":"Database management:",
      "9":"Relational Databases:",
      "10":"Microsoft SQL Server",
      "11":"PostgreSQL",
      "12":"MySQL",
      "13":"Oracle DB",
      "14":"NoSQL database:",
      "15":"Mango DB",
      "16":"Cassandra",
      "17":"Big data Technologies:",
      "18":"Distributed storage:",
      "19":"Hadoop",
      "20":"HBASE",
      "21":"Data processing:",
      "22":"Apache Spark",
      "23":"Presto",
      "24":"Hadoop MapReduce",
      "25":"Programming languages:",
      "26":"Java",
      "27":"Python",
      "28":"Java script",
      "29":"Typescript"
    },
    "cta":"Get started with <br> insightful data."
  },
  "ar": {
    "pageTitle":"البيانات الضخمة والتحليلات",
    "pageDesc":"احصل على رؤى ثاقبة وشاملة من خلال تحليل البيانات الضخمة الموجودة لديك والتي تساعدك على التنبؤ بالتغيرات المستقبلية.",
    "mantra":"اعتمد على البيانات الضخمة |والتحليلات وخطط لمستقبل |أعمالك.",
    "mantraDesc":"نساعدك على بناء مستقبل أعمالك على أساس سليم من خلال الاعتماد على البيانات، واستخدامها كأداة تحليلية من خلال تحليل البيانات التي تم جمعها واستخراج منها الرؤى والحقائق التي تؤثر على أداء العمل وعملية صنع القرار.",
    "sec1":"حول الأرقام إلى بيانات مؤثرة.",
    "sec1Items":{
      "1":{
        "title":"تحليل بيانات العملاء",
        "desc":"كلما زادت معرفتك بسلوك عملائك، زادت قدرتك على زيادة ولائهم. سنساعدك في اكتشاف الإحصاءات المفيدة باستخدام البيانات السابقة."
      },
      "2":{
        "title":"تحليل بيانات المبيعات",
        "desc":"سنساعدك في الحصول على إحصاءات من بيانات المبيعات لتحديد الأهداف والتنبؤ بالمبيعات والطلبات المستقبلية."
      },
      "3":{
        "title":"تحليل بيانات الموارد البشرية",
        "desc":"استخدم بيانات الأفراد التي تم جمعها بواسطة أنظمة الموارد البشرية مثل أداء العمليات؛ لتحسين أداء الموظفين."
      },
      "4":{
        "title":"خدمات التحليلات الأخرى",
        "desc":"نوفر لك المزيد والمزيد من التحليلات التي تحسن من أداء أعمالك مثل تحليل بيانات وسائل التواصل الاجتماعي، وتحليل بيانات الأداء، وتحليل بيانات التجارة الإلكترونية."
      }
    },
    "sec2":"نخصص خدماتنا من أجل احتياجاتك.",
    "sec2Items":{
      "1":{
        "title":"استشارات.",
        "desc":"سيمنحك مستشارينا النصيحة وسوف يساعدونك في الإجابة على أسئلة عملك التى تشغل بالك."
      },
      "2":{
        "title":"تطبيق حلول البيانات",
        "desc":"سنقوم بتطبيق وتحليل متطلبات عملك ونقترح الحل الأمثل لك."
      },
      "3":{
        "title":"تحليل البيانات الخارجية",
        "desc":"نساعدك في الحصول على تقارير تحليلية ومقاييس ثابتة دون القلق من كيفية القيام بذلك. نحتاج فقط إلى إذن منك للوصول إلى بياناتك وسوف نمنحك نتائج عالية الجودة بآمان وبمنتهى الخصوصية."
      }
    },
    "sec3":"استغل قوى التقنيات المتطورة.",
    "sec3Items":{
      "1":"تقنيات ذكاء الأعمال:",
      "2":"Power BI",
      "3":"Tableau",
      "4":"QlikView",
      "5":"Looker",
      "6":"Microsoft SQL Data Tools (SSDT)",
      "7":"Google Analytics",
      "8":"إدارة قواعد البيانات:",
      "9":"Relational Databases:",
      "10":"Microsoft SQL Server",
      "11":"PostgreSQL",
      "12":"MySQL",
      "13":"Oracle DB",
      "14":"NoSQL database:",
      "15":"Mango DB",
      "16":"Cassandra",
      "17":"تقنيات البيانات الضخمة:",
      "18":"Distributed storage:",
      "19":"Hadoop",
      "20":"HBASE",
      "21":"Data processing:",
      "22":"Apache Spark",
      "23":"Presto",
      "24":"Hadoop MapReduce",
      "25":"Programming languages:",
      "26":"Java",
      "27":"Python",
      "28":"Java script",
      "29":"Typescript"
    },
    "cta":"اعتمد على البيانات <br> في أعمالك. "
  }
}
</i18n>
